import { setBeneficiary } from "../../../../redux/slices/beneficiarySlice"
import { store } from "../../../../redux/store"
import { setDeleteBeneficiaryModalOpen } from "../redux/slices/deleteBeneficiaryModalSlice"

export const showDeleteBeneficiaryModal = (beneficiaryId) => {
  store.dispatch(setDeleteBeneficiaryModalOpen(true))
  store.dispatch(setBeneficiary({ id: beneficiaryId }))
}
